import React from 'react';
import { Dialog, DialogTitle, DialogActions, DialogContent, Typography, Button, IconButton } from '@mui/material';
import { useFetchCustomFields } from 'app/data/generic-queries';
import { ActionColumn, Table } from 'app/custom-components';
import { producerCategoriesMap, dataTypesMap } from '../utils';
import { Add } from '@mui/icons-material';

const ManageCustomFieldsDialog = ({ open, onClose, role, handleEdit, handleDelete }) => {
    const { data, isLoading } = useFetchCustomFields({
        queryParams: { where: { role } },
        type: 'user',
    });
    const columns = [
        ActionColumn({
            options: [
                { label: 'Edit', action: handleEdit },
                { label: 'Delete', action: handleDelete },
            ],
        }),
        { field: 'name', headerName: 'Name', flex: 1, type: 'string' },
        { field: 'category', headerName: 'Category', flex: 1, type: 'string', valueFormatter: ({ value }) => producerCategoriesMap[value] },
        { field: 'data_type', headerName: 'Data Type', flex: 1, type: 'string', valueFormatter: ({ value }) => dataTypesMap[value] },
    ];

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span>Manage Custom Fields</span>
                <Button variant="contained" onClick={() => handleEdit({})} startIcon={<Add />}>
                    Add Field
                </Button>
            </DialogTitle>
            <DialogContent>
                <Table
                    getRowId={(row) => row._id}
                    columns={columns}
                    rows={data ?? []}
                    loading={isLoading}
                    hideFooter
                    pagination
                    // wrap
                />
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={onClose}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ManageCustomFieldsDialog;
